import { connect } from "react-redux";

import { ApplicationState } from "../../redux/ApplicationState";
import { RequireAuth } from "../common/RequireAuth";

const mapStateToProps = ({masterFeatureAccessState, loggedInUserState }: ApplicationState) => ({
  loggedInUser: loggedInUserState.response,
  masterFeatureAccessState: masterFeatureAccessState.response,
});

export default connect(mapStateToProps, null)(RequireAuth);